import { TEMPLATE_MANIFEST } from "../templates/manifest.js";

function escapeText(value = "") {
    return String(value ?? "");
}

function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = Boolean(hidden);
}

function renderTemplateItem(template, onOpen) {
    const item = document.createElement("div");
    item.className = "template-gallery-item";

    const body = document.createElement("div");
    const name = document.createElement("div");
    name.className = "template-gallery-item-name";
    name.textContent = escapeText(template.name);

    const description = document.createElement("div");
    description.className = "template-gallery-item-description";
    description.textContent = escapeText(template.description);

    const tags = document.createElement("div");
    tags.className = "template-gallery-tags";
    for (const tagText of template.tags || []) {
        const tag = document.createElement("span");
        tag.className = "template-gallery-tag";
        tag.textContent = escapeText(tagText);
        tags.appendChild(tag);
    }
    const tier = document.createElement("span");
    tier.className = "template-gallery-tag template-gallery-tier";
    tier.textContent = escapeText(template.tier || "free");
    tags.appendChild(tier);

    body.append(name, description, tags);

    const button = document.createElement("button");
    button.className = "template-gallery-open";
    button.type = "button";
    button.textContent = "開く";
    button.addEventListener("click", () => onOpen(template, button));

    item.append(body, button);
    return item;
}

export function createTemplateGallery(deps = {}) {
    const {
        refs = {},
        templates = TEMPLATE_MANIFEST,
        importData,
        confirm: confirmLoad = window.confirm.bind(window),
        setStatus = () => {},
        onBeforeImport = () => {},
        alertFn = window.alert.bind(window)
    } = deps;
    const modal = refs.templateGalleryModal;
    const list = refs.templateGalleryList;
    const openButton = refs.btnOpenTemplateGallery;
    const closeButton = refs.btnCloseTemplateGallery;
    const newProjectButton = refs.btnNewProject;
    const newProjectModal = refs.newProjectChoiceModal;
    const closeNewProjectButton = refs.btnCloseNewProjectChoice;
    const importProjectButton = refs.btnImportProjectFromFile;
    const importFileInput = refs.importFile;
    const openTemplateFromNewProjectButton = refs.btnOpenTemplateGalleryFromNewProject;
    if (!modal || !list || typeof importData !== "function") return null;
    if (modal.dataset.templateGalleryBound === "1") return null;
    modal.dataset.templateGalleryBound = "1";

    const close = () => setHidden(modal, true);
    const open = () => setHidden(modal, false);
    const closeNewProjectChooser = () => setHidden(newProjectModal, true);
    const openNewProjectChooser = () => setHidden(newProjectModal, false);
    const openTemplate = async (template, button) => {
        const ok = confirmLoad("サンプルを読み込みますか？（現在の編集内容は置き換わります）");
        if (!ok) return;
        button.disabled = true;
        button.textContent = "読み込み中";
        try {
            const mod = await template.loader();
            onBeforeImport(template);
            importData(mod.default);
            close();
            setStatus(`${template.name} を読み込みました`);
        } catch (error) {
            console.error(error);
            alertFn("サンプルの読み込みに失敗しました: " + (error?.message || error));
            setStatus("サンプルの読み込みに失敗しました");
        } finally {
            button.disabled = false;
            button.textContent = "開く";
        }
    };

    list.replaceChildren(...templates.map((template) => renderTemplateItem(template, openTemplate)));
    openButton?.addEventListener("click", open);
    closeButton?.addEventListener("click", close);
    newProjectButton?.addEventListener("click", openNewProjectChooser);
    closeNewProjectButton?.addEventListener("click", closeNewProjectChooser);
    openTemplateFromNewProjectButton?.addEventListener("click", () => {
        closeNewProjectChooser();
        open();
    });
    importProjectButton?.addEventListener("click", () => {
        closeNewProjectChooser();
        importFileInput?.click?.();
    });
    modal.addEventListener("click", (event) => {
        if (event.target === modal) close();
    });
    newProjectModal?.addEventListener("click", (event) => {
        if (event.target === newProjectModal) closeNewProjectChooser();
    });
    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        if (newProjectModal && !newProjectModal.hidden) {
            closeNewProjectChooser();
            return;
        }
        if (!modal.hidden) close();
    });

    return { open, close, openNewProjectChooser, closeNewProjectChooser };
}
